import React, { Component } from "react";

import { withRequest } from "../../../utils/request";
import { getCurrentMonthName, getLink } from "../../../utils/helpers";
import Modal from "../../general/Modal";
import CreateRegistro from "../../Vehiculos/Servicios/Create";
import ServiciosPorVencer from "../ServiciosPorVencer";
import SolicitudesPendiente from "../SolicitudesPendiente";
import LicenciasPorVencer from "../LicenciasPorVencer";
import SegurosPorVencer from "../SegurosPorVencer";
import DashboardTabs, { Tab } from "../../general/DashboardTabs";
import CombustibleDisponible from "../CombustibleDisponible";
import AppChart from "../AppChart";
import AppLine from "../AppLine";
import AppCard from "../AppCard";
import GraficoBarras from "../GraficoBarras";
import { NavLink } from "react-router-dom";
import dayjs from "dayjs";

class HomeDashboard extends Component {
	state = {
		ventas: 0,
		viajes: 0,
		dolares: 0,
		depositos: 0,
		topChoferes: [],
		topRutas: [],
		produccionCat: [],
		produccionDelMes: [],
		viajesDelMes: [],
		licenciasPorVencer: [],
		segurosPorVencer: [],
		serviciosPorVencer: [],
		solicitudesPendiente: [],
		gastosPorCategoria: [],
		diasDelMes: [],
		combustibleDisponible: [],
		showRegistro: false,
		vehiculoActivo: {},
		registroActivo: {},
		gastosGenerales: 0,
		gastosCombustible: 0,
		showGastoConfirmation: false,
		activeTab: "servicios",
        anio: dayjs().format("YYYY"),
        mes: dayjs().format("M"),
	};

	componentDidMount() {
		this.getDashboard();
	}
	getDashboard = async (url = "dashboard/gi") => {
		const dashboard = await this.props.request(url);

		if (dashboard.success) {
			this.setState({
				...dashboard.data,
				loading: false,
			});
		}
	};

	activateTab = (tab) => {
		this.setState({
			activeTab: tab,
		});
	};

	isActiveClass = (tab) => {
		return tab === this.state.activeTab ? "active" : "";
	};

	// Mismo caso que onFiltroChange: el `await` no esperaba al re-render y
	// `filtroQuery()` consultaba el mes anterior al que muestra el selector.
	// `mes` es string (viene de dayjs().format("M") y del select), así que el
	// `mes === 12` original nunca era cierto: diciembre pasaba a mes 13.
	nextMonth = () => {
		const { mes, anio } = this.state;

		const siguiente =
			parseInt(mes) === 12
				? { mes: 1, anio: parseInt(anio) + 1 }
				: { mes: parseInt(mes) + 1 };

		this.setState(siguiente, this.filtroQuery);
	};

	prevMonth = () => {
		const { mes, anio } = this.state;

		const anterior =
			parseInt(mes) === 1
				? { mes: 12, anio: parseInt(anio) - 1 }
				: { mes: parseInt(mes) - 1 };

		this.setState(anterior, this.filtroQuery);
	};

	expandRanking = (rank) => {
		this.setState({
			[rank]: !this.state[rank],
		});
	};

	// `await this.setState()` no espera al re-render: setState no devuelve una
	// promesa, así que `filtroQuery()` corría antes de que React aplicara el
	// update y leía el mes/año anteriores. El callback de setState sí corre
	// después del commit.
	onFiltroChange = (e, filtro) => {
		this.setState(
			{ [filtro]: e.target ? e.target.value : e },
			this.filtroQuery
		);
	};

	filtroQuery = () => {
		const query = [`mes=${this.state.mes}`, `anio=${this.state.anio}`];
		this.getDashboard("dashboard/gi?" + query.join("&"));
	};

	toggleRegistroModal = (vehiculo, registro = {}, showGasto = false) => {
		if (vehiculo) {
			this.setState({
				showRegistro: true,
				vehiculoActivo: vehiculo,
				registroActivo: registro,
			});
		} else {
			this.setState({
				showRegistro: false,
				registroActivo: registro,
				showGastoConfirmation: showGasto,
			});
		}
	};
	toggleGastoConfrimation = () => {
		this.setState({
			showGastoConfirmation: !this.state.showGastoConfirmation,
		});
	};

	render() {
        const anioActual = dayjs().format('YYYY');
		const {
			licenciasPorVencer,
			segurosPorVencer,
			serviciosPorVencer,
			solicitudesPendiente,
			mes,
			anio,
			registroActivo,
			diasDelMes,
			combustibleDisponible,
		} = this.state;
		let months = [];
		let years = [];
		for (let month = 0; month < 12; month++) {
			months.push({
				numero: month + 1,
				nombre: getCurrentMonthName(month),
			});
		}
		for (let year = 2012; year <= anioActual; year++) {
			years.push(year);
		}

		const currentMonth =
			mes - 1 + "" + anio ===
			new Date().getMonth() + "" + new Date().getFullYear();

		return (
			<div className="dashboard">
				<section className="dashboard-header">
					<h1>
						Estadísticas {getCurrentMonthName(mes - 1)} {anio}
					</h1>
					<div className="dashboard-dates">
						<button
							className="btn btn-primary"
							onClick={this.prevMonth}
						>
							<i className="zmdi zmdi-chevron-left"></i>
						</button>
						<select
							name="mes"
							value={mes}
							onChange={(e) => this.onFiltroChange(e, "mes")}
							className="form-control"
						>
							{months.map((month) => (
								<option key={month.numero} value={month.numero}>
									{month.nombre}
								</option>
							))}
						</select>
						<select
							name="anio"
							value={anio}
							onChange={(e) => this.onFiltroChange(e, "anio")}
							className="form-control"
						>
							{years.map((year) => (
								<option key={year} value={year}>
									{year}
								</option>
							))}
						</select>
						<button
							className="btn btn-primary"
							onClick={this.nextMonth}
							disabled={currentMonth}
						>
							<i className="zmdi zmdi-chevron-right"></i>
						</button>
					</div>
				</section>

				<AppCard
                    anio={anio}
                    mes={mes}
				/>

				<div className="dashboard-top-section">
					<div className="col-xl-5 spacing dashboard-tabs-widget">
						{solicitudesPendiente &&
							serviciosPorVencer &&
							licenciasPorVencer &&
							segurosPorVencer && (
								<DashboardTabs>
									<Tab
										key="1"
										title="Tareas"
										counter={solicitudesPendiente.length}
									>
										<div className="contenedor-tabs">
										<SolicitudesPendiente
											solicitudes={solicitudesPendiente}
										/>
										</div>

										<div className="ver-mas d-flex justify-content-end align-items-end">
											<NavLink to={getLink("/solicitudes")}>
												<p className="text-secondary">Ver más</p>
											</NavLink>
										</div>
									</Tab>
									<Tab
										key="2"
										title="Servicios"
										counter={serviciosPorVencer.length}
									>
										<div className="contenedor-tabs">

											<ServiciosPorVencer
												servicios={serviciosPorVencer}
												toggleModal={
												this.toggleRegistroModal
												}
											/>
										</div>
										<div className="ver-mas d-flex justify-content-end align-items-end">
											<NavLink to={getLink("/servicios")}>
												<p className="text-secondary">Ver más</p>
											</NavLink>
										</div>
									</Tab>
									<Tab
										title="Licencias"
										key="3"
										counter={licenciasPorVencer.length}
									>
										<div className="contenedor-tabs">

											<LicenciasPorVencer
												licencias={licenciasPorVencer}
											/>
										</div>
										<div className="ver-mas d-flex justify-content-end align-items-end">
											<NavLink target='_blank' to={getLink("/imprimir/reportes?reporte=licencias-vencidas")}>
												<p className="text-secondary">Ver más</p>
											</NavLink>
										</div>
									</Tab>
									<Tab
										key="4"
										title="Seguros"
										counter={segurosPorVencer.length}
									>
										<div className="contenedor-tabs">

											<SegurosPorVencer
												seguros={segurosPorVencer}
											/>
										</div>
										<div className="ver-mas d-flex justify-content-end align-items-end">
											<NavLink target='_blank' to={getLink("/imprimir/reportes?reporte=seguros-vencidos")}>
												<p className="text-secondary">Ver más</p>
											</NavLink>
										</div>
									</Tab>
								</DashboardTabs>
							)}
					</div>
					<div className="col spacing app-dashboard dashboard-tabs-widget">
						<AppChart
							diasDelMes={this.state.diasDelMes}
							chartDashboardData={this.state.chartDashboard}
					/>
					</div>
				</div>

				<div className="dashboard-row">
					<GraficoBarras
						data={{

							totalCompraItems: {
								label: "Inventario Interno",
								value: this.state.graficoBarras
									?.totalCompraItems,
							},
							totalCompraProductos: {
								label: "Inventario de Producto",
								value: this.state.graficoBarras
									?.totalCompraProductos,
							},
							totalCompraSuministros: {
								label: "Trabajo/Suministro",
								value: this.state.graficoBarras
									?.totalCompraSuministros,
							},
							gastosInternos: {
								label: "Despachos internos",
								value: this.state.graficoBarras?.gastosInternos,
							},
						}}
					/>
					<AppLine
						diasDelMes={diasDelMes}
						LastThreeMonthsChartDashboard={
							this.state.lastThreeMonthsChartDashboard
						}
					/>
				</div>

				{combustibleDisponible.length > 0 && (
					<div className="combustible">
						<CombustibleDisponible
							contenedores={combustibleDisponible}
						/>
					</div>
				)}

				<Modal
					show={this.state.showRegistro}
					blank={true}
					toggle={this.toggleRegistroModal}
				>
					<CreateRegistro
						toggle={this.toggleRegistroModal}
						vehiculo={this.state.vehiculoActivo}
						getRegistros={this.getDashboard}
						registro={this.state.registroActivo}
					/>
				</Modal>
				<Modal
					title="Registrar gastos..."
					show={this.state.showGastoConfirmation}
					toggle={this.toggleGastoConfrimation}
					acceptText="Ir a gastos"
					callback={() =>
						this.props.history.push(
							getLink(
								`/gastos/crear?registro=${registroActivo.id}&vehiculo=${registroActivo.vehiculoId}&mecanico=${registroActivo.mecanicoId}`
							)
						)
					}
				>
					¿Deseas registrar los gastos relacionados a este servicio
					ahora?
				</Modal>
			</div>
		);
	}
}

export default withRequest(HomeDashboard);
